// extracted by mini-css-extract-plugin
module.exports = {"content":"CardsWithIcon_content__6QSG4","card":"CardsWithIcon_card__2IkCL","iconContainer":"CardsWithIcon_iconContainer__3di5q"};